import { Stepper, Step, StepLabel, useMediaQuery, useTheme, styled, StepConnector } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';

interface StepperHorizontalProps {
  steps: string[];
  currentStep: number;
  isError: boolean;
  showStepLabel: boolean;
}

export function StepperHorizontal(props: StepperHorizontalProps) {
  const { steps, currentStep, isError, showStepLabel } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const StepConnectorStyled = styled(StepConnector)({
    top: isSmallScreen ? '12px' : '20px',
  });

  return (
    steps?.length > 0 && (
      <Stepper
        sx={{ my: '10px', flexWrap: 'wrap' }}
        activeStep={currentStep}
        alternativeLabel
        connector={<StepConnectorStyled />}
      >
        {steps.map((label, index) => (
          <Step key={index} sx={{ display: 'inline-block', width: '100%', alignItems: 'center' }}>
            <StepLabel
              error={index === currentStep && isError}
              icon={
                index === currentStep && isError ? (
                  <CancelIcon color="error" fontSize={!isSmallScreen ? 'large' : 'medium'} />
                ) : index <= currentStep ? (
                  <CheckCircleIcon color="primary" fontSize={!isSmallScreen ? 'large' : 'medium'} />
                ) : (
                  <CircleIcon sx={{ color: '#bdbdbd' }} fontSize={!isSmallScreen ? 'large' : 'medium'} />
                )
              }
            >
              {showStepLabel && label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    )
  );
}

export default StepperHorizontal;
